import React, { useState } from "react";
import axios from "axios";
import "../../Style/TableStyle.scss";
import "../../Style/__searchbar.scss";
import "../../Style/__button.scss";
import "./ExpencesTypePage.scss";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
  updateAlert,
} from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiFillGolden } from "react-icons/ai";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DataGridWithActions from "../../Components/DataGridWithActions";
import CrudPageHeader from "../../Components/CrudPageHeader";
import ExpencesTypeModal from "./ExpencesTypeModal";
import ExpencesTypeViewModal from "./ExpencesTypeViewModal";

export default function ExpenceTypePage() {
  const headers = authHeader();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedExpence, setSelectedExpence] = useState(null);
  const [viewExpence, setViewExpence] = useState(null);
  const [data, setData] = useState([]);

  const getApiErrorMessage = (error, fallbackMessage) => {
    if (error?.response?.data?.errorMessage) {
      return `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`;
    }
    if (
      typeof error?.response?.data === "string" &&
      error.response.data.trim() !== ""
    ) {
      return error.response.data;
    }
    if (error?.message) {
      return `Gabim: ${error.message}`;
    }
    return fallbackMessage;
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedger",
        { headers, params: { ledger: 609 } },
      );
      setData(response.data);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(
          error,
          "Gabim i panjohur në marrjen e klasave të shpenzimeve.",
        ),
      );
    }
  };

  const handleEdit = async (item) => {
    setSelectedExpence(item);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedExpence(null);
  };

  const handleView = async (item) => {
    setViewExpence(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setViewExpence(null);
  };

  const handleDelete = async (deleteItemId) => {
    try {
      const response = await axios.delete(
        ApiLink.API_URL + "Accounts/expence" + `/${deleteItemId}`,
        { headers },
      );
      const result = response.data;
      if (result.success) {
        handleSuccess("Kategoria e shpenzimeve është fshirë me sukses");
        fetchData();
      } else {
        deleteAlert(
          "Kategoria e shpenzimeve nuk mund të fshihet sepse është përdorur në transaksione",
        );
      }
    } catch (error) {
      deleteAlert(
        "Ka ndodhur një gabim gjatë fshirjes së kategoris së shpenzimeve.",
      );
    }
  };

  const expenceGridHeader = [
    {
      field: "id",
      headerName: "#",
      width: 60,
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      groupable: false,
      aggregable: false,
    },
    {
      field: "AccountName",
      headerName: "Emri i Klases",
      flex: 2.6,
      minWidth: 320,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "LedgerNameEN",
      headerName: "Llogaria Kontabël",
      flex: 1.2,
      minWidth: 200,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "IsActive",
      headerName: "Aktiv",
      width: 90,
      headerClassName: "super-app-theme--header",
      renderCell: (params) =>
        params.value ? (
          <CheckCircleOutlineIcon style={{ color: "green" }} />
        ) : (
          ""
        ),
    },
  ];

  const rows = data.map((item, index) => ({
    id: index + 1,
    AccountName: item.AccountName,
    LedgerNameEN: item.LedgerNameEN,
    IsActive: Boolean(item.IsActive),
    deleteItemId: item.AccountID,
    rowInfo: item,
  }));

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="Crud__Container ETP__page">
      <ExpencesTypeModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        mode="edit"
        initialData={selectedExpence}
        fetchData={fetchData}
      />

      <ExpencesTypeViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        expenseData={viewExpence}
      />

      <CrudPageHeader
        icon={AiFillGolden}
        title="Klasifikimi i Shpenzimeve"
        description="Forma e Klasifikimeve: Menaxhoni, shtoni, editoni dhe fshini Klasa të shpënzimeve."
        tutorialUrl="https://www.youtube.com/@Accountree"
        tutorialLabel="Shiko Tutorialin"
        action={
          <ExpencesTypeModal
            fetchData={fetchData}
            type="text"
            className="button-68"
          />
        }
        className="ETP__header"
      />

      <DataGridWithActions
        columns={expenceGridHeader}
        rows={rows}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleShowPrint={handleView}
        showPayment={false}
        height={500}
        showDetailsStatus={true}
        modernStyle={true}
      />
    </div>
  );
}
